<div class="view-container">
  <mat-card class="fulfilment-card">
    <div class="fulfilment-card__header">
      <div class="fulfilment-card__title-row">
        <div class="fulfilment-card__icon">
          <mat-icon>inventory_2</mat-icon>
        </div>
        <div>
          @if (order) {
            <h1 class="fulfilment-card__title">Order #{{ order.id }}</h1>
            <div class="fulfilment-card__meta">
              <span [class]="getStatusPillClass(order.status)">
                {{ order.status.status }}
              </span>
              @if (company && !individual) {
                <span class="fulfilment-card__entity">{{ company.name }}</span>
              }
              @if (individual && !company) {
                <span class="fulfilment-card__entity">
                  {{ individual.first_name }} {{ individual.last_name }}
                </span>
              }
              @if (getEntityPhone()) {
                <span class="fulfilment-card__entity">{{ getEntityPhone() }}</span>
              }
            </div>
          }
        </div>
      </div>
    </div>

    <mat-accordion multi="true" class="fulfilment-card__accordion">
      <mat-expansion-panel expanded="true" class="fulfilment-card__panel">
        <mat-expansion-panel-header>
          <mat-panel-title class="fulfilment-card__panel-title">
            Not scanned
          </mat-panel-title>
          <mat-panel-description class="fulfilment-card__panel-desc">
            These items need to be scanned
          </mat-panel-description>
        </mat-expansion-panel-header>
        <core-order-item-fulfilment-list
          [items]="unscannedFulfilmentItems"
          [displayedColumns]="unScannedFulfilmentItemsDisplayedColumns"
        >
        </core-order-item-fulfilment-list>
      </mat-expansion-panel>

      <mat-expansion-panel expanded="true" class="fulfilment-card__panel">
        <mat-expansion-panel-header>
          <mat-panel-title class="fulfilment-card__panel-title">
            Scanned
          </mat-panel-title>
          <mat-panel-description class="fulfilment-card__panel-desc">
            These items have been scanned
          </mat-panel-description>
        </mat-expansion-panel-header>
        <core-order-item-fulfilment-list
          [items]="scannedFulfilmentItems"
          [displayedColumns]="scannedFulfilmentItemsDisplayedColumns"
        >
        </core-order-item-fulfilment-list>
      </mat-expansion-panel>
    </mat-accordion>

    @if (order) {
      <div class="fulfilment-card__footer">
        <button
          (click)="gotoPrescriptionReview()"
          [routerLink]="['/portal/prescriptions/review', order.id]"
          mat-flat-button
          color="primary"
          class="fulfilment-card__done-btn"
        >
          <mat-icon>done</mat-icon> Done
        </button>
      </div>
    }
  </mat-card>
</div>
